import { isBrowser, safeExecute } from '@/utils/runtime'

/* --------------------------------------------------
   Works both *before* and *after* the real bundle
   is downloaded.  Falls back to snippet queue.
--------------------------------------------------- */
const getSDK = () => (isBrowser ? window.Moengage ?? null : null)
const enqueue = (method, ...args) => {
  if (isBrowser && typeof window.moe === 'function') {
    window.moe(method, ...args) // snippet queue
  }
}

/* ---------- Public API expected by analytics/ -------- */

export const initMoEngage = () => {} // handled in _app.tsx

export const track = (name, params = {}) => {
  const moe = getSDK()
  moe?.track_event
    ? safeExecute(() => moe.track_event(name, params))
    : enqueue('track_event', name, params)
}

export const identify = (id, mobile = '') => {
  const moe = getSDK()
  if (moe) {
    safeExecute(() => {
      moe.add_unique_user_id(id)
      if (mobile) moe.add_mobile(mobile)
    })
  } else {
    enqueue('add_unique_user_id', id)
    if (mobile) enqueue('add_mobile', mobile)
  }
}

export const logout = () => {
  const moe = getSDK()
  if (moe?.destroy_session) safeExecute(() => moe.destroy_session())
}
